import React, {ChangeEvent, useEffect} from "react";
import {IDropDownItemViewModel} from "../../models/item-model/drop-down-item-view-model.interface";
import {IDropDownListViewModel} from "../../models/list-model/drop-down-list-view-model.interface";
import {observer} from "mobx-react";
import styled from "styled-components";
import {XCloseButtonComponent} from "../../../basic-componentes/x-close-button.component";
import {IDropDownController} from "../../drop-down-controller.interface";
import {InputBox} from "../input/input.box";
import {BOX_BORDER_RADIUS_PX, VERTICAL_SPACING_PX} from "../../../css-global-constants";


const SearchBox = styled(InputBox)`
    flex-grow: 1;
    
`

const SearchBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  border-radius: ${BOX_BORDER_RADIUS_PX};
  border: 1px solid ${props => props.theme.colors.medium};
  margin-bottom: ${VERTICAL_SPACING_PX};
  padding: 0 4px 0 4px;
  height: 30px;
`


const DropDownListSearchBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`

interface DropDownListSearchComponentProps<TItem extends IDropDownItemViewModel> {
    listViewModel: IDropDownListViewModel<TItem>;
    dropDownController: IDropDownController;
}


export const DropDownSearchComponent = observer(<TItem extends IDropDownItemViewModel>(props: DropDownListSearchComponentProps<TItem>) => {
    const inputRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
        if(inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.focus();
        }
    });

    const onCloseClick = () => {

        if(inputRef.current?.value) {
            props.listViewModel.currentInputText = "";
            inputRef.current.focus();
        } else {
            props.dropDownController.closeDropDown();
        }
    }

    const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        props.listViewModel.currentInputText = event.target.value ?? "";
    }

    return (
        <DropDownListSearchBox>
            <SearchBoxContainer>
                <SearchBox ref={inputRef}
                           value={props.listViewModel.currentInputText}
                           placeholder={props.listViewModel.inputPlaceholder}
                           onChange={onChangeHandler}/>
                <XCloseButtonComponent onClick={onCloseClick}/>
            </SearchBoxContainer>


        </DropDownListSearchBox>

    )
});
